import type { AppMode } from '@iheartjane/types';
import { useQuery } from '@tanstack/react-query';

import { getJwt } from '@jane/shared/auth';
import { createUseQueryHook, janeApi } from '@jane/shared/data-access';
import type { Cart } from '@jane/shared/types';

import type { FetchQuickCartsParams, QuickCarts } from './quickCart.types';
import { quickCartQueryKeys, quickCartUrls } from './quickCart.util';

const fetchQuickCarts = (params: FetchQuickCartsParams) =>
  janeApi.get<QuickCarts>(
    quickCartUrls.quickCart +
      `?store_id=${params.storeId}&limit=${params.limit}`,
    getJwt()
  );

export const useGetQuickCarts = createUseQueryHook<
  FetchQuickCartsParams,
  QuickCarts
>(
  fetchQuickCarts,
  quickCartQueryKeys.quickCarts,
  (params: FetchQuickCartsParams) => {
    return !!params.storeId && !!params.limit;
  }
);

const getQuickCart = async (uuid: string, appMode: AppMode): Promise<Cart> => {
  const queryParams = new URLSearchParams({ uuid, app_mode: appMode });
  const { cart } = await janeApi.get<{ cart: Cart }>(
    `/carts?${queryParams}`,
    getJwt()
  );
  return cart;
};

export const useGetQuickCart = (
  uuid: string,
  appMode: AppMode,
  initialData: Cart
) => {
  return useQuery({
    queryKey: quickCartQueryKeys.quickCart(uuid, appMode),
    queryFn: () => getQuickCart(uuid, appMode),
    initialData,
  });
};
